import { render, staticRenderFns } from "./PanelV2.vue?vue&type=template&id=4aad9004"
import script from "./PanelV2.vue?vue&type=script&lang=js"
export * from "./PanelV2.vue?vue&type=script&lang=js"
import style0 from "./PanelV2.vue?vue&type=style&index=0&id=4aad9004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports